import {createAction, props} from '@ngrx/store';
import { ResetPassword } from '../../../auth/model/reset-password';

export const logout = createAction('[Auth] Logout');
export const updateToken = createAction(
  '[Auth] Update token',
  props<{token: string}>()
);
export const setUser = createAction(
  '[Auth] Set User',
  props<{token: string, language: string}>()
);
export const changeUserLanguage = createAction(
  '[Auth] Change User Language',
  props<{language: string}>()
);
export const forgotPassword = createAction(
  '[Auth] Forgot Password',
  props<{userName: string}>()
);
export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{data: ResetPassword}>()
);

export type AuthActionsUnion = ReturnType<
  typeof logout |
  typeof updateToken |
  typeof setUser |
  typeof changeUserLanguage |
  typeof forgotPassword |
  typeof resetPassword
  >;
